import React from "react"
export function Shortlist(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M13.6 3C16.064 3 18 4.978 18 7.496c0 3.09-2.72 5.608-6.84 9.433l-.48.442a1 1 0 01-1.359-.002L7.29 15.477C4.051 12.431 2 10.18 2 7.496 2 4.978 3.936 3 6.4 3c1.392 0 2.728.662 3.6 1.708C10.872 3.662 12.208 3 13.6 3zm0 1.5c-.854 0-1.711.382-2.313 1.018l-.135.15L10 7.052 8.848 5.67C8.243 4.943 7.32 4.5 6.4 4.5c-1.628 0-2.9 1.3-2.9 2.996 0 .664.177 1.317.551 2.026.689 1.304 1.69 2.432 4.437 5.019l1.515 1.413.994-.924c3.064-2.868 4.165-4.063 4.893-5.399l.064-.118c.371-.706.546-1.356.546-2.017 0-1.697-1.272-2.996-2.9-2.996z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__shortlist"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
